import React from 'react'
import { WidgetProps } from '@rjsf/utils'
import { useOptionsForAllStorages } from '@features/storages'

import { useSelectPortalRef } from '../../../../../../SelectPortalProvider'
import { getCalcValueSubtraction } from '../Storage/utils'
import { FeedbotCreatableSelect } from '../../../../../selects'
import {
  interpretInputAsStorageExpression,
  sanitizeStorageExpression
} from '../../../../../../../lib/storage'

export const StepStorageSummaryWidget: React.FC<WidgetProps> = ({
  value,
  formContext,
  onChange: uiSchemaOnChange
}) => {
  const portalRef = useSelectPortalRef()
  const storagesOptions = useOptionsForAllStorages()

  const calcValueSubtraction = getCalcValueSubtraction(formContext)

  return (
    <span style={{ width: `calc(80% - ${calcValueSubtraction})` }}>
      <FeedbotCreatableSelect
        isClearable={true}
        openMenuOnFocus={false}
        menuPortalTarget={portalRef}
        createOptionPosition={'first'}
        value={{ value, label: value }}
        className="e2e-select-step-storage"
        options={storagesOptions}
        placeholder="Enter storage name or custom expression"
        formatCreateLabel={inputValue => {
          return interpretInputAsStorageExpression(inputValue)
            ? `Custom expression: ${inputValue}`
            : `Create storage "${inputValue}"`
        }}
        onChange={option => uiSchemaOnChange(sanitizeStorageExpression(option?.value))}
      />
    </span>
  )
}
